const carMakesTranslate = {
    "mercedes": "Mercedes",
    "bmw": "BMW",
    "volkswagen": "Volkswagen",
    "mitsubishi": "Mitsubishi",
    "kia": "Kia",
    "toyota": "Toyota",
    "alfaRomeo": "Alfa Romeo",
    "brilliance": "Brilliance",
    "changan": "Changan",
    "chery": "Chery",
    "chevrolet": "Chevrolet",
    "citroen": "Citroen",
    "daewoo": "Daewoo",
    "daihatsu": "Daihatsu",
    "fiat": "Fiat",
    "ford": "Ford",
    "gmc": "GMC",
    "geely": "Geely",
    "honda": "Honda",
    "hyundai": "Hyundai",
    "isuzu": "Isuzu",
    "jeep": "Jeep",
    "jetour": "Jetour",
    "lada": "Lada",
    "lexus": "Lexus",
    "mazda": "Mazda",
    "mini": "Mini",
    "nissan": "Nissan",
    "opel": "Opel",
    "proton": "Proton",
    "peugeot": "Peugeot",
    "renault": "Renault",
    "skoda": "Skoda",
    "subaru": "Subaru",
    "suzuki": "Suzuki",
    "tesla": "Tesla",
    "volvo": "Volvo",
    "audi": "Audi",
    "bentley": "Bentley",
    "byd": "BYD",
    "astonMartin": "Aston Martin",
    "avatr": "Avatr",
    "baic": "Baic",
    "porsche": "Porsche",
    "cadillac": "Cadillac",
    "chrysler": "Chrysler",
    "cupra": "Cupra",
    "ds": "DS",
    "kgm": "KGM",
    "gac": "GAC",
    "landrover": "Land Rover",
    "mclaren": "McLaren",
    "mg": "MG",
    "rollsRoyce": "Rolls Royce",
    "ssangYong": "Ssang Yong",
    "alpine": "Alpine",
    "bestune": "Bestune",
    "dodge": "Dodge",
    "dongfeng": "Dongfeng",
    "exceed": "Exceed",
    "faw": "FAW",
    "ferrari": "Ferrari",
    "forthing": "Forthing",
    "haima": "Haima",
    "haval": "Haval",
    "hummer": "Hummer",
    "infiniti": "Infiniti",
    "jac": "Jac",
    "jaguar": "Jaguar",
    "lamborghini": "Lamborghini",
    "maserati": "Maserati",
    "lotus": "Lotus",
    "zeekr": "Zeekr",
    "seat": "Seat",
    "zotye": "Zotye",
};

export default carMakesTranslate;